import { useNavigate } from 'react-router-dom';
import { Layout as PageLayout } from 'modules/app/components/templates/generic-page-layout/Layout';

export const NotFound = () => {
  const displayTitle = "Sorry, but we can't find the page you were looking for.";
  const displayMessage =
    "This doesn't mean we can't help you find a solution for your financial future.";

  const navigate = useNavigate();
  const goHome = () => {
    navigate('/');
  };

  return (
    <PageLayout
      title={displayTitle}
      subtitle={displayMessage}
      buttons={[
        {
          title: 'Go home',
          onClick: async () => goHome()
        }
      ]}
    />
  );
};
